/**
 * pmReveal — reveal elements matching `selector` as they scroll into view by
 * adding the `pm-in` class (styling lives in src/motion.scss, gated on html.pm-js).
 * Additive only. Reduced-motion or no IntersectionObserver reveals everything at once.
 * Returns a cleanup fn for useEffect.
 */
export default function initPmReveal(selector) {
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (reduce || !('IntersectionObserver' in window)) {
    document.querySelectorAll(selector).forEach((el) => el.classList.add('pm-in'))
    return () => {}
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('pm-in')
          io.unobserve(e.target)
        }
      })
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  )
  const scan = () =>
    document.querySelectorAll(selector).forEach((el) => {
      if (!el.classList.contains('pm-in')) io.observe(el)
    })
  scan()
  const t1 = setTimeout(scan, 300) // sections mounted just after paint
  const t2 = setTimeout(scan, 1200) // lazily-rendered sections
  return () => {
    io.disconnect()
    clearTimeout(t1)
    clearTimeout(t2)
  }
}
